// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-icon {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background-color: #183055;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: 100%;\n  mask-repeat: no-repeat;\n  mask-size: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
